import { RequestStatusStyles } from '@src/utils/enums';

const RequestStatus = ({ value }) => {
  if (!value) return null;

  const statusStyle = RequestStatusStyles[value] || 'draft';
  return <span className={`request-status-tag ${statusStyle}`}>{value}</span>;
};

export default RequestStatus;
